import React from "react";
import Table from "react-bootstrap/Table";
import { useEffect } from "react";
import axios from ".././axios-interceptor";
import { useState } from "react";
import NavBarMain from "./NavBarMain";
import { base_url } from "./../utilities";
import KycDocumentsModel from "./KYCDocumentsModel";
import SideNavBar from "./SideNavBar";
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const KYCDocuments = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
}, []);

  const [modalShow, setModalShow] = React.useState(false);
  const [businessDcouments, setBusinessDocuments] = useState([]);
  const [businessdataUser, setBusinessdataUser] = useState([]);
  const [download, setDownload] = useState([]);
  const [uploadedDocument, setSelectedDocument] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedDoc, setSelected] = useState([]);
  useEffect(() => {
    axios
      .post(base_url + "business-master/get_business_data_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        setBusinessdataUser(res.data.data);
        let business = { business_id: res.data.data.business_id }
        axios
          .post(base_url + "documents-type/get_documents_by_business", business)
          .then((res) => {
            setBusinessDocuments(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Business");
          Cookies.remove("User_Refreshtoken_Business");
          navigate("/");
        }
      });
    axios
      .post(base_url + "documents-type/get_document_types", {})
      .then((res) => {
        let doctypes = res.data.data;
        let x = [];
        doctypes.BUSINESS_KYC_MANDATORY.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
        setDownload(x);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = businessdataUser.business_name +"_"+document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err)
    }


  };
  
  

  download.forEach((eachItem) => {
    businessDcouments.forEach((businessUploaded) => {
      if (eachItem.doc_type == businessUploaded.document_type) {
        eachItem.is_upload = true;
        eachItem.document_url = businessUploaded.document_url;
        eachItem.expiry_date = businessUploaded.expiry_date;
      }
    })
  })

  const openKycModel = (item) => {
    setSelectedDocument(item)
    setModalShow(true)
  }
  const addDoc = () => {
    setSelectedDocument(null)
    setModalShow(true)
  }
  const handleCloseRejectClose = () => {
    setShow(false)
  }
  // const handleShowReject = (value) => {
  //   setSelected(value);
  //   setShow(true)
  // };
  const titles = ["Type", "Expiry", "Uploaded By", "Actions"]
  const [docTypeValue, setDocTypeValue] = useState([])

  const handleDocClick = (e) => {

    setDocTypeValue(e.target.lastChild.nodeValue)
  }
  // const handleCloseReject = () => {
  //   let document_id = { document_id: selectedDoc.document_id }
  //   axios
  //       .post(base_url + "documents-type/delete_document", document_id)
  //       .then((res) => {
  //           if (res.data.status == 200) {
  //               setShow(false)
  //               toast.success("Deleted Successfully", {
  //                   toastId: 4
  //               })
  //               setTimeout(() => {
  //                 window.location.reload();
  //             }, 800);
  //           }
  //       })

  // };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <SideNavBar />
      <div className='myloanheader w-100'>
        <NavBarMain businessname={businessdataUser?.business_name} />
       <div className={`ps-4 pe-4 mt-2 `}>
          <div className="d-flex justify-content-between mb-2">
            <div className=" d-flex gap-4 align-items-center ">
              <h1 className=""> KYC Documents</h1>
            </div>
            <div className="">
              <button className="blue_btn bt_style" onClick={() => addDoc()}>Add Documents</button>&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <KycDocumentsModel show={modalShow} data={uploadedDocument}
            onHide={() => setModalShow(false)} />
          <div className="row ">
            <div className="col-8  pe-4">
              <div className="bus_kyc_table">
                <Table  striped  className=" my_loan_table " >
                  <thead>
                    <tr>
                      {titles.map((title, id) => (
                        <th key={id} >{title}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {businessDcouments.map((doc, index) => {
                      return (
                        <tr key={index}>
                          <td >{doc.document_type == undefined ? '-' : doc.document_type}</td>
                          <td className={doc.expiry_date > new Date() ? '': 'text-danger'}>{doc.expiry_date == null ? '-' : moment(doc.expiry_date).format('DD MMM YYYY') }</td>
                          <td>{doc.created_by == undefined ? '-' : doc.created_by}</td>
                          <td >
                            <div className="d-flex justify-content-evenly">
                              <div className='align-self-center' >
                                <a style={{ display: "table-cell" }} href={doc.document_url} target="_blank">
                                  <img src="./images/eye.svg" alt="" /></a>
                              </div>
                              <div className=' ps-3 Cpointer' onClick={() => handleDownload(doc.document_url, doc.document_type)}><img src="./images/down.svg" alt="" /></div>
                              {/* <div  ><i className=" del_bin_style fa-solid fa-trash" onClick={()=>handleShowReject(doc)}></i></div> */}
                            </div></td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="col-4 card">
              <div className="row">
                <div className="text_styles mt-2 mb-3">Mandatory Documents</div>
              </div>
              <div className="kyc_man_doc_tab">
                {download.map((item, index) => {
                  let len = download.length
                  return (
                    <div className="row mt-1" key={item.doc_type} style={{height:""}}>
                      <div className="col-8 ps-4">
                        <div className="text_st_new" onClick={(e) => handleDocClick(e)}>{item.doc_type}</div>
                        {item.is_upload == true ?
                          <div className={`exp_date `}>Expiry Date : <span className={`text_st1 ${item.expiry_date > new Date()  ? '': 'expirydangerstyl'}`}>{item.expiry_date == null ? "--" : moment(item.expiry_date).format('DD MMM YYYY')}</span></div> : ""}
                          {item.expiry_date > new Date() ||item.expiry_date == null ? '' : <div className="expiredtxt">Expired</div> }
                        {item.is_upload == true ?
                          <div className={` ${index == len -1 ? 'up_new mb-2' : 'up_new mb-2'}`} onClick={() => openKycModel(item)}>Upload New</div> :
                          <div className={`${index == len -1 ? 'up_new mb-3' : 'up_new mt-2 mb-2'}`} onClick={() => openKycModel(item)}>Upload Document</div>}
                      </div>
                      {item.is_upload == true ? <div className="col-4 ps-3 ">
                        <span className='indiv_loan_dtls' ><a
                          style={{ display: "table-cell" }} href={item.document_url} target="_blank"
                        ><img src="./images/eye.svg" alt="" /></a></span>
                        <span className='Cpointer ps-3' onClick={() => handleDownload(item.document_url, item.doc_type)}><img src="./images/down.svg" alt="" /></span>
                      </div> : ""}
                      {index !== len - 1 && <hr style={{ color: "grey",  }} />}
                    </div>)
                })}
              </div>
            </div>
          </div>
        </div> 
        <div>
        </div>
      </div>
      
    </div>


  )
}

export default KYCDocuments;
